<template>
    <div class="p10" v-loading.body="loading">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="6">
                <h1 style="padding-top:5px;">回款登记单</h1>
            </el-col>
            <el-col :span="18" class="tr">
                <template v-if="infoData.status == 1">
                    <ly-button-time @timeUpdate="timeUpdate" 
                        :infoid="infoId"
                        :type="20"
                        :date="infoData.work_time" 
                        v-if="buttonConfig.isUpdateTime">
                    </ly-button-time>
                    <ly-bntton-invalid 
                        size="small"
                        :info-id="infoId"
                        :is-route="currRoute.api"
                        is-style="回款登记"
                        v-if="buttonConfig.isInvalid"
                        :callback="invalidCallback">
                    </ly-bntton-invalid>
                    <ly-router-button
                        size="small"
                        :route="'/bill/' + currRoute.path + '/edit/' + infoId"
                        type="primary"
                        v-if="buttonConfig.isEdit">
                            <i class="fa fa-edit"></i>&nbsp;修改
                    </ly-router-button>
                </template>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <el-card class="box-card mt15">
            <el-row>
                <el-col :span="12">
                    <el-button-group>
                        <template v-if="infoData.last_id && infoData.last_id > 0">
                            <el-button type="info"  size="small" @click="toggoleInfo(infoData.last_id)">
                                <i class="fa fa-chevron-left"></i> 前一张
                            </el-button>
                        </template>
                        <template v-if="infoData.next_id && infoData.next_id > 0">
                            <el-button type="info"  size="small" @click="toggoleInfo(infoData.next_id)">
                                后一张 <i class="fa fa-chevron-right"></i> 
                            </el-button>
                        </template>
                    </el-button-group>
                </el-col>
                <el-col :span="12" class="tr">
                    <template v-if="infoData.status">
                        <ly-tag tag-category="paycheckin" :tag-status="infoData.status"></ly-tag>
                    </template>
                    <template v-if="infoData.is_jindie == 1">
                        <el-tag type="warning">已发送金蝶</el-tag>
                    </template>
                </el-col>
            </el-row>
            <!-- 单据信息 start -->
            <ly-information 
                :config="infoConfig"
                :data="infoData"
                class="mt15">        
            </ly-information>
            <!-- 单据信息 end -->
        </el-card>

        <!-- 客户列表 start -->
        <ly-table 
            :head="customerConfig.head" 
            :data="infoData.customer" 
            :config="customerConfig.config"
            class="mt15">
        </ly-table>
        <!-- 客户列表 end -->
        <!-- 对账信息 start -->
        <el-card class="box-card mt15" v-if="infoData.status == 2 && infoData.duizhanglist">
            <template slot='header'>
            <div>对账信息</div>
            </template>
            <ly-information 
                :config="billConfig"
                :data="infoData.duizhanglist">        
            </ly-information>
        </el-card>
        <!-- 对账信息 end -->
        <!-- 处理记录 start -->
        <el-card class="box-card mt15">
            <template slot='header'>
            <div>
                <span>处理记录</span>
            </div>
            </template>
            <p class="f12 mt10 ctext" v-for="el in infoData.history">
                {{el}}
             </p>
        </el-card>
        <!-- 处理记录 end -->
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import InfoConfig from './info-config'
    import LyInformation from '@c/information'
    import LyTable from '@c/table'
    import LyTag from '@c/tag'
    import LyRouterButton from '@c/router-button'
    import LyBnttonInvalid from '@c/button-invalid'
    import LyButtonTime from '@c/button-time'
    export default {
        mixins: [
            InfoConfig
        ],
        components: {
            LyTable,
            LyTag,
            LyInformation,
            LyRouterButton,
            LyBnttonInvalid,
            LyButtonTime
        },
        data () {
            return {
                infoId: '0',
                loading: false,
                infoData: {}, // 详情的数据，包含货品数据、处理记录
                buttonConfig: {} // 按钮的配置
            }
        },
        computed: {
            ...mapGetters('route', [
                'currRoute'
            ])
        },
        watch: {
            '$route' (to, from) {
                // 路由变化时，更新配置
                if (to.name === 'PaymentCheckinInfo') {
                    this.queryInfoData()
                }
            }
        },
        mounted () {
            this.queryInfoData()
        },
        methods: {
            /**
             * 作废成功后的回调
             */
            invalidCallback () {
                // 改变当前单据状态
                this.$set(this.infoData, 'status', 3)
            },
            /**
             * 详情页面的切换
             */
            toggoleInfo (id) {
                // 跳转到的路由
                let path = '/bill/' + this.currRoute.path + '/info/' + id
                this.routerJump(path)
            },
            /**
             * 路由跳转处理
             * @param  {[type]} path [description]
             * @return {[type]}      [description]
             */
            routerJump (path) {
                path = path.replace('#', '')
                this.loading = true
                this.$router.push(path)
            },
            /**
            /**
             * 获取详情的数据
             */
            queryInfoData () {
                this.readRouteConfig()
                // 获取详情的ID
                this.infoId = this.$route.params.id
                this.$api.query(this.currRoute.api ,{
                    route: this.currRoute.path
                    // info: this.getField(this.infoConfig), // 获取详情需要的字段
                    // product: this.getField(this.productConfig.head) // 获取货品中需要的字段
                }, [this.infoId]).then((rs) => {
                    this.loading = false
                    this.infoData = rs
                }).catch((error) => {
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 读取当前页面的路有配置
             */
            readRouteConfig () {
                // 获得当前页面的配置
                 let routeConfig = this.$utils.readPageConfig(this.currRoute, 'info')
                // 获得button的配置
                if (routeConfig && routeConfig.config) { 
                    this.buttonConfig = routeConfig.config.button ? JSON.parse(routeConfig.config.button || '') : {}
                }
            },
            /**
             * 日期修改之后的事件监听
             */
            timeUpdate () {
                // 详情数据刷新
                this.queryInfoData()
            }
        }
    }
</script>